(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3DeletedScores', {
            templateUrl: 'app/shared/deleted-scores/deleted-scores.component.html',
            controller: DeletedScoresComponent,
            bindings: { deletedScores: '<' }
        });

    var isUndefined = angular.isUndefined,
        noop = angular.noop;

    DeletedScoresComponent.$inject = ['$scope', '$state', 'user', 'Score', 'alert', 'confirm', 'scoreHistoryPageSize', 'scoring_resources', 'signInManager'];
    function DeletedScoresComponent($scope, $state, user, Score, alert, confirm, scoreHistoryPageSize, resources, signInManager) {
        var ctrl = this;

        // Properties
        ctrl.page = 1;
        ctrl.pageSize = scoreHistoryPageSize;
        Object.defineProperty(ctrl, 'pageCount', { get: getPageCount });
        Object.defineProperty(ctrl, 'dateFormat', { get: getDateFormat });
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });
        ctrl.isNationalLookupAdmin = user.isNationalLookupAdmin;

        // Methods
        ctrl.previous = seek.bind(ctrl, -1);
        ctrl.next = seek.bind(ctrl, 1);

        ////////////////////////////////////////////////////
        function seek(offset, origin) {
            var page = origin === 'begin' ? 1 : origin === 'end' ? ctrl.pageCount : ctrl.page,
                newPage = Math.max(page + offset, 1),
                pageSize = ctrl.pageSize,
                individualId = ctrl.deletedScores.individualId;

            Score.getDeletedScores({ individualId: individualId, $skip: (newPage - 1) * pageSize, $top: pageSize }, success, error, true);

            function success(deletedScores) {
                var pageCount = getPageCount(deletedScores.total, pageSize),
                    isPastTheEnd = !deletedScores.data.length && pageCount;

                if (isPastTheEnd)
                    return seek(0, 'end');
                ctrl.deletedScores = deletedScores;
                ctrl.page = newPage;
                return deletedScores;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.scoreHistoryRequestFailed);
                return $q.reject(rejection);
            }
        }
        function getPageCount(totalCount, pageSize) {
            totalCount = isUndefined(totalCount) ? ctrl.deletedScores.total : totalCount;
            pageSize = isUndefined(pageSize) ? ctrl.pageSize : pageSize;
            return Math.ceil(totalCount / pageSize);
        }
        function getDateFormat() {
            return 'shortDate';
        }
        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }
    }
})();